import { useAppDispatch } from "@/store";
import Layout from "@/layout/layout";
import { wrapper } from "@/store";
import {
  fetchBlogList,
  fetchBlogListByCategory,
  selectBlog,
} from "@/store/slices/blog";
import { selectHelmet, setMeta, setOg, setPath, setSchemas, setTitle } from "@/store/slices/helmet";
import styles from "@/styles/blog_new.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { ReactElement, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";

const Blog = () => {
  const blogState = useSelector(selectBlog);
  const helmetState = useSelector(selectHelmet);
  const dispatch = useAppDispatch();
  const router = useRouter();

  useEffect(() => {
    dispatch(fetchBlogListByCategory(router.query.slug as string));
  }, [dispatch, router.query.slug]);

  if (blogState.loading) {
    return (
      <>
        <div className={styles.blog_bg}>
          <div className="container">
            <div className={styles.heading}>Blogs</div>
          </div>
        </div>
        <div className={styles.blog_list}>
          <div className="row mb-5">
            <div className="col-lg-8 col-md-7">
              <Skeleton style={{ height: 300, marginLeft: 100 }} />
            </div>
            <div className="col-lg-1 col-md-1"></div>
            <div className="col-lg-2 col-md-3">
              <Skeleton style={{ height: 300 }} />
            </div>
          </div>
        </div>
      </>
    );
  }

  if (!blogState.list) {
    return <></>;
  }

  return (
    <>
      <div className={styles.blog_bg}>
        <div className="container">
          <div className={styles.heading}>Blogs1</div>
        </div>
      </div>
      <div className={styles.blog_list}>
        <div className="container my-5">
          <div className="row">
            <div className="col-lg-8 col-md-7">
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <div className={styles.card}>
                    <div className="position-relative w-100">
                      <figure className={styles.figure}>
                        <Image
                          src={blogState.list.recent_posts[0].image}
                          alt={blogState.list.recent_posts[0].title}
                          layout="fill"
                          priority
                        />
                      </figure>
                    </div>
                    <div className="d-flex mt-4 icon-color">
                      <div className="d-flex align-items-center me-2">
                        <p className="mt-1 mb-0">
                          <i className="bi bi-calendar-check"></i>{" "}
                          {blogState.list.recent_posts[0].date}
                        </p>
                      </div>
                      <div className="d-flex align-items-center">
                        <p className="mt-1 mb-0">
                          | <i className="bi bi-person ms-2"></i>{" "}
                          {blogState.list.recent_posts[0].user}
                        </p>
                      </div>
                    </div>
                    <div className={styles.pading_0}>
                      <Link
                        href={`/blog/${blogState.list.recent_posts[0].slug}`}
                        passHref
                      >
                        <div className="d-inline-block">
                          <div className={styles.heading}>
                            {blogState.list.recent_posts[0].title}
                          </div>
                        </div>
                      </Link>
                    </div>
                    <Link
                      href={`/blog/${blogState.list.recent_posts[0].slug}`}
                      passHref
                    >
                      <div className={styles.news_btn}>READ MORE</div>
                    </Link>
                    <div className="d-flex justify-content-between mt-2 mb-5 border-top border-bottom">
                      <div className="d-flex align-items-center me-2">
                        <h6 className="mt-0 mb-0">Share</h6>
                      </div>
                      <div className="d-flex justify-content-end align-items-center me-2">
                        <div className={styles.social_links}>
                          <a className="twitter" target="_blank" href="#">
                            <i className="bi bi-twitter"></i>
                          </a>
                          <a className="facebook" target="_blank" href="#">
                            <i className="bi bi-facebook"></i>
                          </a>

                          <a className="linkedin" target="_blank" href="#">
                            <i className="bi bi-whatsapp"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {blogState.list.data.map((item: any) => (
                  <div className="col-md-12 col-lg-6 " key={item.slug}>
                    <div className={styles.card_two}>
                      <div className="position-relative w-100">
                        <figure className={styles.figure}>
                          <Image
                            src={item.image}
                            alt={item.title}
                            layout="fill"
                          />
                        </figure>
                      </div>
                      <div className="d-flex mt-4 icon-color">
                        <div className="d-flex align-items-center me-2">
                          <p className="mt-1 mb-0">
                            <i className="bi bi-calendar-check"></i> {item.date}
                          </p>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="mt-1 mb-0">
                            | <i className="bi bi-person ms-2"></i> {item.user}
                          </p>
                        </div>
                      </div>
                      <div className={styles.pading_0}>
                        <Link href={`/blog/${item.slug}`} passHref>
                          <div className="d-inline-block">
                            <div className={styles.heading}>{item.title}</div>
                          </div>
                        </Link>
                        <Link href={`/blog/${item.slug}`} passHref>
                          <div className={styles.news_btn}>READ MORE</div>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center mb-5">
                <ReactPaginate
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  nextLabel="Next"
                  onPageChange={(e) => {
                    dispatch(
                      fetchBlogList({
                        page: e.selected + 1,
                      })
                    );
                  }}
                  pageCount={blogState.list.last_page}
                  forcePage={blogState.list.current_page - 1}
                  previousLabel="Prev"
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-5">
              <div className={styles.blog_sidebar}>
                <h2>About us</h2>

                <div className={styles.logo_blog}>
                  <Image
                    className="img-fluid"
                    src={require("@/assets/images/logo-blog.jpg")}
                    alt="alt"
                  />
                </div>
                <p className="text-center">{blogState.list.about}</p>
                <div className={styles.social_links1}>
                  <a href="#" className="twitter">
                    <i className="bx bxl-twitter"></i>
                  </a>
                  <a href="#" className="facebook">
                    <i className="bx bxl-facebook"></i>
                  </a>
                  <a href="#" className="google-plus">
                    <i className="bx bxl-youtube"></i>
                  </a>
                  <a href="#" className="instagram">
                    <i className="bx bxl-instagram"></i>
                  </a>

                  <a href="#" className="linkedin">
                    <i className="bx bxl-whatsapp"></i>
                  </a>
                </div>
              </div>

              <div className={styles.category}>
                <h3>Categories</h3>

                <ul>
                  <li>
                    <Link href="/blog">View All</Link>
                  </li>
                  {blogState.list.categories.map((category: any) => (
                    <li key={category.name}>
                      <Link href={`/blog/category/${category.slug}`}>
                        <a>
                          {category.name} ({category.post_count})
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className={styles.recent_post}>
                <h4>Recent Blogs</h4>
                {blogState.list.recent_posts.map((post: any) => (
                  <Link href={`/blog/${post.slug}`} key={post.slug} passHref>
                    <div className="row g-0 pointer">
                      <div className="col-lg-4 col-md-6">
                        <Image
                          className="img-fluid"
                          src={post.image}
                          alt="Post image"
                          width={110}
                          height={50}
                        />
                      </div>
                      <div className="col-lg-8 col-md-6">
                        <div className={styles.h4}>
                          {post.title.substring(0, 55)}...
                        </div>
                        <p>{post.date}</p>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Blog.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ resolvedUrl, params }) => {
      const slug = params?.slug as string;

      // SEO data mapping for different categories
      const categorySEO: Record<string, { title: string; description: string; keywords: string }> = {
        "jewellery-care": {
          title: "Jewellery Care Tips & Maintenance Guide | Senco Gold & Diamonds Blog",
          description: "Discover expert jewellery care tips, cleaning methods and maintenance guides for gold, diamond and gemstone jewellery. Keep your jewellery shining with Senco Gold & Diamonds.",
          keywords: "jewellery care tips, jewellery cleaning, gold jewellery maintenance, diamond care, gemstone care, jewellery storage",
        },
        "love-stories": {
          title: "Love Stories & Real Wedding Jewellery Moments | Senco Gold & Diamonds",
          description: "Read beautiful love stories and real wedding journeys featuring Senco jewellery. Get inspired by engagement, proposal and wedding jewellery moments.",
          keywords: "love stories, real wedding stories, engagement stories, proposal jewellery, wedding jewellery inspiration",
        },
        "style-guide": {
          title: "Jewellery Style Guide – How to Wear & Style Jewellery | Senco Blog",
          description: "Explore the Senco jewellery style guide for styling tips, outfit pairings and trend inspiration. Learn how to wear gold and diamond jewellery effortlessly.",
          keywords: "jewellery style guide, how to style jewellery, jewellery fashion tips, outfit jewellery pairing, jewellery trends",
        },
      };

      // Get SEO data for the current slug or use default
      const seoData = categorySEO[slug] || {
        title: "Blogs | Senco Gold & Diamonds",
        description: "One Stop Destination to buy Gold & Diamond Jewellery. Senco Gold sells the best quality of Rings, Earrings, Necklaces with wide varieties of collections.",
        keywords: "",
      };

      store.dispatch(setPath(resolvedUrl));
      store.dispatch(setTitle(seoData.title.split("|")[0].trim()));
      store.dispatch(
        setMeta({
          title: seoData.title,
          description: seoData.description,
          keywords: seoData.keywords,
        })
      );
      store.dispatch(
        setOg({
          type: "website",
          url: `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
          title: seoData.title,
          description: seoData.description,
          image: "",
        })
      );

      const metaTitle = seoData.title;
      const metaDescription = seoData.description;
      const h1Text = seoData.title.split("|")[0].trim() || "Blogs";

      const speakableSchemaObj = {
        "@context": "https://schema.org",
        "@type": "SpeakableSpecification",
        "cssSelector": [
          `"metaTitle": "${metaTitle}"`,
          `"metaDescription": "${metaDescription}"`,
          `"H1": "${h1Text}"`,
        ],
      };

      const speakableSchemaStr = JSON.stringify(speakableSchemaObj);
      store.dispatch(setSchemas([speakableSchemaStr]));

      return {
        props: {},
      };
    }
);

export default Blog;
